import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Container from "react-bootstrap/Container";
import ReactQuill from 'react-quill';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import CategoryList from "../CategoryList";
import 'react-quill/dist/quill.snow.css';
import UploadLogo from "../modals/UploadLogo";
import CatalogService from "../../services/catalog.service";

const AdminAddProduct = () => {
    // title, description, htmlDescription, maker, source, brandLogo, styleImage, styleThumb, specSheet, measurements
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const [errorMessage, setErrorMessage] = useState(null);
    const [editedHtmlDescription, setEditedHtmlDescription] = useState('');
    const [showDescription, setShowDescription] = useState(false);
    const [colorSwatchColor, setColorSwatchColor] = useState('#000000');
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [file, setFile] = React.useState(null);

    const onSubmit = async (data) => {
        data.uploadedImage = [file];
        data.categories = [...selectedCategories];
        data.description = editedHtmlDescription;
        data.hexColor = colorSwatchColor;
        const response = await CatalogService.addProduct(data);
        console.log(response);
    }

    const updateIgniteCategoryForStyle = async (categoryId, checked) => {
        if(checked)
            setSelectedCategories([...selectedCategories, categoryId]);
        else {
            var cats = [...selectedCategories];
            const index = cats.indexOf(categoryId);
            if (index > -1) {
                cats.splice(index, 1);
            }
            setSelectedCategories(cats);
        }
    }

    const validateDescription = () => {
        return editedHtmlDescription != null && editedHtmlDescription != "";
    }

    const validateCategories = () => {
        return selectedCategories.length > 0;
    }

    return (
        <Container>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <input
                    type="hidden"
                    id="description"
                    {...register('description', {
                        validate: validateDescription,
                    })}
                />
                <input
                    type="hidden"
                    id="categories"
                    {...register('categories', {
                        validate: validateCategories,
                    })}
                />


                <div class="product-details-container">
                    <div class="product-img-lg">
                        <UploadLogo title="Product Image" register={register} fieldName="uploadedImage" bgColor="#FFFFFF" currentLogo={null} setFile={setFile} width={"90%"} />
                    </div>
                    <div class="product-content">
                        <div style={{ borderBottom: "1px solid #000" }}>
                            <Form.Group className="mb-3" controlId="title">
                                <Form.Label className="sectionTitle">Title</Form.Label>
                                <input {...register("title", { required: true })} /><br />
                                {errors.title && <div className="error" >Title is required</div>}
                            </Form.Group>
                        </div>
                        <div style={{ borderBottom: "1px solid #000" }}>
                            <Form.Group className="mb-3" controlId="modelCode">
                                <Form.Label className="sectionTitle">Model Code</Form.Label>
                                <input {...register("modelCode", { required: true })} /><br />
                                {errors.modelCode && <div className="error" >Model Code is required</div>}
                            </Form.Group>
                        </div>
                        <div style={{ paddingBottom: 15, borderBottom: "1px solid #000" }}>
                            <Form.Label className="sectionTitle">Description</Form.Label>

                            <ReactQuill theme="snow" value={editedHtmlDescription} onChange={setEditedHtmlDescription} />
                            {errors.description && (
                                <div className="error" >Description is required</div>
                            )}
                        </div>
                        <div style={{ borderBottom: "1px solid #000" }}>
                            <Form.Group className="mb-3" controlId="price">
                                <Form.Label className="sectionTitle">Price</Form.Label>
                                <input {...register("price", { required: true })} /><br />
                                {errors.price && <div className="error" >Price is required</div>}
                            </Form.Group>
                        </div>

                        <div style={{ borderBottom: "1px solid #000" }}>
                            <CategoryList editEnabled={true} updateIgniteCategoryForStyle={updateIgniteCategoryForStyle} />
                            {errors.categories && (
                                <div className="error" >Select at least 1 category</div>
                            )}

                        </div>
                        <div style={{ borderBottom: "1px solid #000" }}>
                            <Form.Group className="mb-3" controlId="colorName">
                                <Form.Label className="sectionTitle">Color Name</Form.Label>
                                <input {...register("colorName", { required: true })} /><br />
                                {errors.colorName && <div className="error" >Color Name is required</div>}
                            </Form.Group>
                        </div>
                        <div style={{ borderBottom: "1px solid #000" }}>
                            <Form.Label htmlFor="colorSwatchColor" className="sectionTitle">Color Swatch Color</Form.Label>
                            <Form.Control
                                type="color"
                                id="colorSwatchColor"
                                defaultValue={colorSwatchColor}
                                title="Choose your color"
                                onChange={(e) => setColorSwatchColor(e.target.value)}
                                style={{ height: 75, width: 75 }}

                            />
                        </div>
                        <div style={{ borderBottom: "1px solid #000" }}>
                            <Form.Group className="mb-3" controlId="size">
                                <Form.Label className="sectionTitle">Size</Form.Label>
                                <input {...register("size", { required: true })} /><br />
                                {errors.size && <div className="error" >Size is required</div>}
                            </Form.Group>
                        </div>
                        <div style={{ borderBottom: "1px solid #000" }}>
                            <Form.Group className="mb-3" controlId="maker">
                                <Form.Label className="sectionTitle">Maker</Form.Label>
                                <input {...register("maker", { required: true })} /><br />
                                {errors.maker && <div className="error" >Maker is required</div>}
                            </Form.Group>
                        </div>
                        <Button onClick={handleSubmit(onSubmit)}>Add Product</Button>
                    </div>
                </div>
            </Form>
        </Container>

    );
}

export default AdminAddProduct;